import { COMMAND_CENTER_ROOT } from './commandCenterRoutes'
import { useNavigate } from 'react-router-dom'
import { GovernanceProvider, OliviumSuiteHome } from './olivium/governance'

/**
 * V2 Olivium Governance Suite — home route wrapper.
 *
 * Registered standalone + auth-gated (see router.tsx):
 *   /square/command-center/olivium
 *
 * This is where the Final Hub "Olivium" tile lands: the static
 * `workspaces/olivium` route redirects here (ranked above the generic
 * `workspaces/:divisionId`), so no normal route opens the old Command Center
 * division view for Olivium. The suite home surfaces the durable access
 * surfaces and the seven governance workspaces; navigation is real routes.
 */
export default function SquareCodeOliviumSuiteRoute() {
  const navigate = useNavigate()
  return (
    <GovernanceProvider>
      <OliviumSuiteHome
        onOpenPath={(to) => navigate(to)}
        onHome={() => navigate(COMMAND_CENTER_ROOT)}
      />
    </GovernanceProvider>
  )
}
